/*!
 * Normalizes a SalesId for API calls by stripping display prefixes like "Order#".
 */
export const normalizeSalesIdForApi = (raw: unknown): string | undefined => {
    if (raw === undefined || raw === null) {
        return undefined;
    }

    let text = String(raw).trim();
    if (!text) {
        return undefined;
    }

    // Strip display prefix like "Order# 000004599" or "Order# pahc-000281".
    text = text.replace(/^order\s*#\s*/i, '').trim();
    if (!text) {
        return undefined;
    }

    // Extract trailing hyphenated IDs when embedded in longer display text.
    const hyphenatedMatch = text.match(/([A-Za-z0-9]+-[A-Za-z0-9-]+)$/);
    if (hyphenatedMatch?.[1]) {
        return hyphenatedMatch[1];
    }

    return text;
};
